export default "__VITE_ASSET__BHsrpGT$__"